import actions from '../../actionTypes';

export default (status) => {
  return {
    type: actions.VERIFY_PASSWORD_TOKEN_COMPLETED,
    status
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/verifyPasswordTokenCompleted.js